export default __webpack_public_path__ + "static/media/blur_tech.881965dc.png";